import React, {Component} from "react";
import {connect} from "react-redux";
import SVGIcon from "../../svg/SVGIcon";
import SVGImage from "../../svg/SVGImage";

import "./EmployersPriorities.css";

class EmployersPriorities extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0
    }
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrev = this.onClickPrev.bind(this);
  }

  onClickNext() {
    const {activeTab} = this.state;
    const next = (activeTab === 3)?0:activeTab+1;
    this.setState({activeTab:next});
  }

  onClickPrev() {
    const {activeTab} = this.state;
    const prev = (activeTab === 0) ? 3 : activeTab - 1;
    this.setState({activeTab: prev});
  }

  render() {
    const {baseUrl} = this.props;
    const {activeTab} = this.state;
    return (
      <div id="fow-employers-priorities" className="fow-row">
        <div className="fow-col-1">
          <div className="fow-employers-priorities-controls">
            <div className="fow-employers-priorities-control fow-employers-priorities-control-prev fow-font-text" onClick={this.onClickPrev}><SVGIcon name="prev" height="13" width="13" stroke="#000"/><span>Prev</span></div>
            <span className="fow-employers-priorities-current fow-font-text">{activeTab+1} - 4</span>
            <div className="fow-employers-priorities-control fow-employers-priorities-control-next fow-font-text" onClick={this.onClickNext}><span>Next</span><SVGIcon name="next" height="13" width="13" stroke="#000" /></div>
          </div>
          <div className="fow-employers-priorities-container">
            <SVGImage src={`${baseUrl}home/employers-${activeTab+1}.svg`} />
          </div>
          <div className="fow-employers-priorities-legend-container">
            <SVGImage src={`${baseUrl}home/employers-legend.svg`} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    baseUrl: state.settings.baseUrl,
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmployersPriorities);
